import { createStore } from '../core/store.ts';

/**
 * Запрос поиска. Поле ввода живёт в нижней панели на месте вкладок, а результаты — на экране
 * поиска, поэтому текст общий.
 */
export const searchQueryStore = createStore('');
